module.exports = __webpack_public_path__ + "static/media/Billing.a4f94c81.svg";